import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { LANGUAGE } from '../locales/config'

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`../locales/${language}/${namespace}.json`)
    )
  )
  .init({
    fallbackLng: LANGUAGE.SV,
    debug: process.env.NODE_ENV === 'development',
    ns: [
      'start-screen',
      'treatment-screen',
      'city-screen',
      'clinic-screen',
      'appointment-screen',
      'booking-summary-screen',
      'calendar-modal',
      'jumbotron',
      'my-bookings',
      'your-bookings',
      'booking-confirmation-screen',
      'add-to-calendar',
      'contact-information-screen',
      'booking-alert',
      'progressbar',
      'confirm-alert',
    ],
    detection: {
      order: ['navigator'],
    },
    react: {
      useSuspense: false,
    },
  })

export default i18n
